import { configureStore } from '@reduxjs/toolkit';
import consumeSlice from './consumeSlice';
import partsSlice from './partsSlice';
import rotableSlice from './rotableSlice';

export default configureStore ({
    reducer: {
        partTypeState: partsSlice,
        consumeState: consumeSlice,
        rotableState: rotableSlice               
    }
})